<template>
  <div
    :class="$style.overlay"
    class="b_overlay"
    :style="overlayCssStyle"
    v-if="isVisible"
  >
    <slot/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {

  props: {

    visible: {
      type: Boolean,
      required: true,
    },
  },

  data () {
    return {
      zIndex: null,
    }
  },

  computed: {

    ...mapState({
      openedOverlaysCount: state => state.overlay.index,
    }),

    overlayCssStyle () {
      return this.zIndex
        ? `z-index:${this.zIndex};`
        : ''
    },

    isVisible () {
      return this.visible && this.zIndex
    },
  },

  methods: {
    ...mapActions({
      show: 'overlay/show',
      hide: 'overlay/hide',
    }),
  },

  beforeUnmount () {
    if (this.zIndex) {
      this.hide()
    }
  },

  watch: {

    visible: {
      immediate: true,
      handler: async function (value) {
        if (value) {
          this.zIndex = await this.show()
        } else {
          this.zIndex = false
          this.hide()
        }
      },
    },

    openedOverlaysCount: {
      immediate: true,
      handler: function (value) {
        const c = '-with-overlay'
        const l = document.body.classList
        if (value) {
          if (!l.contains(c)) {
            l.add(c)
          }
        } else {
          l.remove(c)
        }
      },
    },
  },
}
</script>

<style lang="scss" module>
@layer legacy-views {

:global {
  body.-with-overlay {
    overflow: hidden
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--color-gray-16);
  overflow: auto;

  @include media-breakpoint-desktop {
    left: var(--sidebar-width);
    width: calc(100% - var(--sidebar-width));
  }
}

}</style>
